// Tutorial.js
var Tutorial = pc.createScript('tutorial');

Tutorial.attributes.add('tutorialPanel', {type: 'entity'});
Tutorial.attributes.add('tutorialMovePanel', {type: 'entity'});
Tutorial.attributes.add('tutorialMoveEnt', {type: 'entity'});
Tutorial.attributes.add('factorMoveEnt', {type: 'entity'});
Tutorial.attributes.add('factorPanel', {type: 'entity'});
Tutorial.attributes.add('factorBar', {type: 'entity'});

Tutorial.attributes.add('spawnObjects', {type: 'entity'});
Tutorial.attributes.add('homeMenuBtn', {type: 'entity'});
Tutorial.attributes.add('passBtn', {type: 'entity'});

var isFactorTutorialCompleted = false;

Tutorial.prototype.initialize = function () {

    Tutorial.instance = this;
    this.factorProgresStatus = false;
    this.isMoveObjectCompleted = false;
    this.isCheckMoveTutorialStatus = false;
    this.isCheckFactorTutorialStatus = false;

    this.tween = this.tutorialMoveEnt.tween(this.tutorialMoveEnt.getLocalPosition()).to({ x: 0, y: -816, z: 0 }, 1.5, pc.SineOut).loop(true);
    this.factorTween = this.factorMoveEnt.tween(this.factorMoveEnt.getLocalPosition()).to({ x: -160.128, y: 0, z: 0 }, 1.5, pc.SineOut).loop(true);

    this._element = this.factorBar.element;
    this._element.material = this._element.material.clone();
    this.factorProgress = 0.12;
    isFactorTutorialCompleted = false;
    
    this.passBtn.button.on('click', function (event) {
        this.passTutorialView();
    }, this);

};

Tutorial.prototype.moveObjectTutorialOnOff = function(bool){
    
    if(bool){
        this.pauseAction();
        this.tutorialPanel.enabled = true;
        this.tutorialMovePanel.enabled = true;
        this.isCheckMoveTutorialStatus = false;
        this.isCheckFactorTutorialStatus = false;
        this.tween.start();
    }
    else{
        this.tween.stop();
        this.continueAction();
         this.tutorialPanel.enabled = false;
        this.tutorialMovePanel.enabled = false;
        this.isMoveObjectCompleted = true;
       
    }
};

Tutorial.prototype.moveFactorTutorialOnOff = function (bool) {
    
    if(bool){
        this.pauseAction();
        this.tutorialPanel.enabled = true;
        this.factorPanel.enabled = true;
        this.factorProgresStatus = true;
        this.factorTween.start();
        isFactorTutorialCompleted = true;
    }
    else{
        this.factorTween.stop();
        this.continueAction();
         this.tutorialPanel.enabled = false;
        this.factorPanel.enabled = false;
        isFactorTutorialCompleted = true;
    }
};

Tutorial.prototype.pauseAction = function() {
    this.homeMenuBtn.enabled = false;
    Timer.instance.PauseTimer();
    TimeBar.instance.pauseBar();
    ScoreManager.instance.isPaused(); 
};

Tutorial.prototype.continueAction = function() {
    this.homeMenuBtn.enabled = true;
    Timer.instance.ContinueTimer();
    TimeBar.instance.continueBar();
    ScoreManager.instance.isContinue(); 
    
};

Tutorial.prototype.update = function(dt) {
    if(this.factorProgresStatus){
        this.setProgress(this.factorProgress + (dt * 0.3));
        if (this.factorProgress >= 0.9) {
            this.factorProgresStatus = false;
        } 
    }
};

Tutorial.prototype.setProgress = function (value) {
    this.factorProgress = pc.math.clamp(value, 0.0, 1);
    this._element.material.alphaTest = 1-this.factorProgress;
};

Tutorial.prototype.shineEffect = function(){
    shine.tween(shine.getLocalPosition()).to({x : 0, y : -98.086, z : 2.524},1,pc.Linear).on('complete', function(){ Tutorial.instance.scaleEffectStageOne(); }).start();
};

Tutorial.prototype.scaleEffectStageOne = function(){
    currentEntity.tween(currentEntity.getLocalScale()).to(new pc.Vec3(0.8, 0.8, 0.8), 0.2, pc.Linear).on('complete', function(){ Tutorial.instance.scaleEffectStageTwo(); }).start();
};

Tutorial.prototype.scaleEffectStageTwo = function(){
    shine.setLocalPosition(new pc.Vec3(-250,0,0));
    currentEntity.tween(currentEntity.getLocalScale()).to(new pc.Vec3(1, 1, 1), 0.2, pc.Linear).on('complete', function(){ Tutorial.instance.shineEffect();}, this).start();
};

